export default [
  {
    path: '/set-part-to-use',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'SetPartToUse',
        component: () => import('./containers/SetPartToUseContainer'),
      },
    ],
  },
]
